export default __webpack_public_path__ + "static/media/chest_press_start.fcda1f11.svg";